import bem from 'utils/bem';
import { MAX_CHARS_CAPTIONS_PREVIEW } from './constants';

export const block = bem('tiktok-post-modal');

export function formatCaptions(val: string): string | undefined {
  if (typeof val !== 'string') {
    return undefined;
  }

  return val.substring(0, MAX_CHARS_CAPTIONS_PREVIEW);
}
